import React from 'react';
import { useSelector } from 'react-redux';

import { FormattedMessage } from 'react-intl';
import {
  Wrapper,
  ArticlesWrapper,
  PrimaryArticle,
  SecondaryNewsItem,
  ArticleText,
  PrimaryContent,
  Category,
  PrimaryTitle,
  SecondaryNewsImg,
  SecondaryNewsContent,
  Title,
} from './styles';

const CurrencyArticles = () => {
  const articlesList = useSelector(state => state.currency.articlesList);
  const articleBlocks = (Array.isArray(articlesList) ? articlesList : [])
    .map(block =>
      Array.isArray(block)
        ? block.filter(entry => entry && entry.article)
        : null
    )
    .filter(block => block && block.length > 0);

  const renderFirstArticle = item => {
    return (
      <PrimaryArticle key={item.title} href={item.url}>
        <img
          src={`${process.env.APP_MINFIN_API_DOMAIN}${item.img}`}
          alt={item.alt}
        />
        <PrimaryContent>
          <Category>{item.section}</Category>
          <PrimaryTitle>{item.title}</PrimaryTitle>
          <ArticleText>{item.description}</ArticleText>
        </PrimaryContent>
      </PrimaryArticle>
    );
  };

  const renderArticle = item => {
    return (
      <SecondaryNewsItem key={item.title} href={item.url}>
        <SecondaryNewsContent>
          <Category>{item.section}</Category>
          <ArticleText>{item.title}</ArticleText>
        </SecondaryNewsContent>
        <SecondaryNewsImg
          src={`${process.env.APP_MINFIN_API_DOMAIN}${item.img}`}
          alt={item.alt}
        />
      </SecondaryNewsItem>
    );
  };

  if (articleBlocks.length === 0) {
    return null;
  }

  return (
    <Wrapper>
      <Title>
        <FormattedMessage id="currency.articles.mainTitle" />
      </Title>

      <ArticlesWrapper>
        {articleBlocks.map((block, index) => {
          return (
            // eslint-disable-next-line react/no-array-index-key
            <div key={index}>
              {block.map(({ article }, articleIndex) => {
                if (articleIndex === 0) {
                  return renderFirstArticle(article);
                }

                return renderArticle(article);
              })}
            </div>
          );
        })}
      </ArticlesWrapper>
    </Wrapper>
  );
};

export default React.memo(CurrencyArticles);
